var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v("HeartBeatFam Family Game Nights")]),_c('div',{attrs:{"id":"debugElement"}}),_c('h6',[_vm._v("Memory Match")]),_c('h6',[_vm._v("Gone Fishing")]),_c('h6',[_vm._v("Bubble Pop")]),_c('h6',[_vm._v("\n    Show Animation of Game -- and \"Good Job, Good Job\"\n    Show Box for Input to connect\n    Poll Connection\n\n  ")])])
}]

export { render, staticRenderFns }